<template>
  <div class="footer footer-full-width pt-0" id="footer">
    <div class="container">
      <div class="row">
        <div class="nav nav-pills nav1 header-menu w-100 col-sm-12">
          <ul class="w-100 text-center footer-icons-list">
            <li class="nav-item">
              <router-link to="/landing-help">
                <h5 class="nav-link m-0 p-0">Help</h5>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                :to="{path: '/landing-help', query: {open: 'terms-conditions'}}"
              >
                <h5>Terms/conditions</h5>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
              :to="{path: '/landing-help', query: {open: 'privacy-policy'}}"
              >
                <h5>Privacy policy</h5>
              </router-link>
            </li>
            <li class="nav-item">
              <a href="http://blog.swampum.com/" target="_blank" rel="noopener">
                <h5 class="nav-link m-0 p-0">Blog</h5>
              </a>
            </li>
            <li class="nav-item">
              <router-link
                to="contact-us"
                data-cy="lpContactUs"
              >
                <h5 class="nav-link m-0 p-0">Contact</h5>
              </router-link>
            </li>
            <li class="social-icons-container">
              <a
                href="https://www.facebook.com/Swampum/"
                target="_blank"
                class="nav-item"
                rel="noopener"
              >
                <img src="/svg-icons/facebookIcon.png" alt="facebookIcon" />
              </a>
              <a
                href="https://twitter.com/swampum"
                target="_blank"
                class="nav-item"
                rel="noopener"
              >
                <img src="/svg-icons/twitterIcon.png" alt="twitterIcon" />
              </a>
              <a
                href="https://www.instagram.com/swampumllc/"
                target="_blank"
                class="nav-item"
                rel="noopener"
              >
                <img src="/svg-icons/instagramIcon.png" alt="instragramIcon" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>
<style lang="scss" scoped>
a:hover,
h5:hover {
  color: $primary !important;
}
.header-menu a {
  padding: 10px 30px;
}
.container {
  max-width: 100% !important;
}
.footer-icons-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
}

.social-icons-container {
  display: flex;
}

.footer-icons-list li a {
  padding: unset;
}

.footer-icons-list img {
  width: 18px;
}

.nav-item {
  width: unset !important;
  padding: 15px 15px !important;
}

@media only screen and (max-width: 768px) {
  .header-menu {
    transform: none !important;
    position: relative;
    height: auto;
    padding-bottom: 1rem;
    padding-top: 1rem;
  }

  .social-media {
    display: inline;
  }
}
</style>
